export const Experiments: Record<string, number> = {
    CARIBOU_SSO_PROMOTION_EXPERIMENT: 5110,
};

export const AllocationGroups = {
    A: 1,
    B: 2,
    C: 3,
    D: 4,
    E: 5,
} as const;
